import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BoxSx from './BoxSx';
import ClientProvider from './client';
export default createDemo(import.meta.url, BoxSx, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/components/box/demos/sx/BoxSx.tsx",
    "fileName": "BoxSx.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { Box, ThemeProvider } from '@mui/system';\n\nexport default function BoxSx() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider\n      theme={{\n        palette: {\n          primary: {\n            main: '#007FFF',\n            dark: '#0066CC',\n          },\n        },\n      }}\n    >\n      <Box\n        sx={{\n          width: 100,\n          height: 100,\n          borderRadius: 1,\n          bgcolor: 'primary.main',\n          '&:hover': {\n            bgcolor: 'primary.dark',\n          },\n        }}\n      />\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 28,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { Box, ThemeProvider } from '@mui/system';\n\nexport default function BoxSx() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider\n      theme={{\n        palette: {\n          primary: {\n            main: '#007FFF',\n            dark: '#0066CC',\n          },\n        },\n      }}\n    >\n      <Box\n        sx={{\n          width: 100,\n          height: 100,\n          borderRadius: 1,\n          bgcolor: 'primary.main',\n          '&:hover': {\n            bgcolor: 'primary.dark',\n          },\n        }}\n      />\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 28,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
